import { render, staticRenderFns } from "./PageDigitalAnalytics.vue?vue&type=template&id=32e2d491&"
import script from "./PageDigitalAnalytics.vue?vue&type=script&lang=js&"
export * from "./PageDigitalAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports